export function formatAgo(timestamp: number | null, now: number = Date.now()): string {
  if (timestamp == null || !Number.isFinite(timestamp)) return 'never';
  const s = Math.floor((now - timestamp) / 1000);
  if (s < 5) return 'just now';
  if (s < 60) return `${s}s ago`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  return `${Math.floor(h / 24)}d ago`;
}
